import React from 'react'
import { FormError } from 'react-pagebuilder/pb-components/atoms'
import groupBy from 'lodash/groupBy'

const FormSelect = ({
  options = [],
  placeholder = '',
  name = '',
  value = '',
  className = '',
  readOnly = false,
  disabled = false,
  status = '',
  errorMessage = '',
  onBlur = () => {},
  onFocus = () => {},
  onChange = () => {},
}) => {
  const classNames = `
    pb-form-select 
    ${status ? ` pb-form-select--${status}` : ''}
    ${className ? ` ${className}` : ''}`

  const groupedOptions = groupBy(options, 'groupLabel')
  const hasMultipleGroups = Object.keys(groupedOptions)?.length > 1

  return (
    <div className={classNames}>
      <select
        name={name}
        value={value}
        className="pb-form-select__input"
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {hasMultipleGroups
          ? Object.keys(groupedOptions).map((groupLabel) => (
              <optgroup label={groupLabel} key={groupLabel}>
                {groupedOptions[groupLabel].map((option) => (
                  <option value={option.value} key={option.value}>
                    {option.label}
                  </option>
                ))}
              </optgroup>
            ))
          : options.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
      </select>
      <FormError
        className="pb-form-input__error"
        message={errorMessage}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormSelect
